import {ActionsUnion, createAction} from "../definitions";
import {DvirLogActionTypes} from "./types";
import { IDVIRLog } from "../../model/DVIRLog";

interface DvirLogPayload {
    userId: string;
    logs?: IIdDictionary<IDVIRLog>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DvirLogActions = {
    /**
     * Set DVIR Logs in storage
     * @param payload Logs being set in storage
     */
    setDvirLogs: (payload: DvirLogPayload) => createAction(DvirLogActionTypes.SET_DVIR_LOGS, payload),
    /**
     * Used to clear DVIR Logs from storage
     * Logs still awaiting upload (modified Add/Set) survive the clear even for users not in keepUsers.
     * @param keepUsers Optional array of {@link IUser}s for which DvirLogs should be kept.
     */
    clearDvirLogs: (keepUsers?: IUser[]) => createAction(DvirLogActionTypes.CLEAR_DVIR_LOGS, { keepUsers })
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DvirLogActions = ActionsUnion<typeof DvirLogActions>;